import { Navigate, useLocation } from "react-router-dom";

import { jwt } from "../utils/index.js";

const GuestOnly = ({ c }) => {
	const location = useLocation();
	return jwt.isAuthenticated()
		? <Navigate to="/" state={{ from: location }} />
		: c;
};

export default GuestOnly;
